import { useQuery } from 'react-query';

import {
  savedMessagesRoute,
  savedMessagesKey,
  SavedMessage,
  enterpriseCompaniesGet,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';
import { Company } from '@staffedupusa/shared-components';

type usetGetSingleCompanyDataProps = {
  enabled: boolean;
  selectedCompanyId?: string | number;
};

export const usetGetSingleCompanyData = ({ enabled, selectedCompanyId }: usetGetSingleCompanyDataProps) => {
  const { data: companyData } = useQuery<{ object?: Company }>(
    [selectedCompanyId],
    {
      enabled: enabled && selectedCompanyId !== null,
      queryFn: () =>
        axiosInstance.get(enterpriseCompaniesGet + `?company_id=${selectedCompanyId}`).then((res) => res.data),
      refetchOnWindowFocus: false,
    },
  );

  return {
    companyData,
  };
};
